import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import useUser from "../../../../core/hooks/use-user";
import { crearSoftware } from "../../services/software-service";
import { selectSolictudesPorColaborador } from "../../../Solicitudes/services/solicitudes-soporte-service";

const FormSoftware = ({ modalState, onSave }) => {
    const { getUserData } = useUser();
    const [solicitudes, setSolicitudes] = useState([]);
    const user = getUserData();

    useEffect(async () => {
        const resp = await selectSolictudesPorColaborador(user.id);
        if (!resp.status) return toast.error(resp.message);
        setSolicitudes(resp.data);
    }, []);

    const form = useForm();

    const onCreateSoftware = async (software) => {
        const resp = await crearSoftware({
            ...software,
            solicitud_id: software.solicitud_id.value,
        });
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formSoftware"
            isOpen={modalState.show}
            onSubmit={onCreateSoftware}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        name="nombre"
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Nombre"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        label="Solicitudes"
                        name="solicitud_id"
                        errors={form.formState.errors}
                        control={form.control}
                        options={solicitudes.map((solicitud) => {
                            return {
                                label: solicitud.info_solicitud,
                                value: solicitud.id,
                            };
                        })}
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        name="proposito"
                        label="Proposito"
                        type="textarea"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Proposito"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        name="alcance"
                        label="Alcance"
                        type="textarea"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Alcance"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormSoftware.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormSoftware;
